/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Series_OpenInputs */

const en_us2_body_assessment_series_open = /** @type {(inputs: Body_Assessment_Series_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the photo assessments`)
};

const pt_br2_body_assessment_series_open = /** @type {(inputs: Body_Assessment_Series_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver as avaliações por foto`)
};

const es_419_body_assessment_series_open = /** @type {(inputs: Body_Assessment_Series_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir las evaluaciones por foto`)
};

const pt_pt2_body_assessment_series_open = /** @type {(inputs: Body_Assessment_Series_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver as avaliações por foto`)
};

const fr_fr2_body_assessment_series_open = /** @type {(inputs: Body_Assessment_Series_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les évaluations par photo`)
};

const de_de2_body_assessment_series_open = /** @type {(inputs: Body_Assessment_Series_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotomessungen öffnen`)
};

const it_it2_body_assessment_series_open = /** @type {(inputs: Body_Assessment_Series_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri le valutazioni da foto`)
};

/**
* | output |
* | --- |
* | "Open the photo assessments" |
*
* @param {Body_Assessment_Series_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_series_open = /** @type {((inputs?: Body_Assessment_Series_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Series_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_series_open(inputs)
	if (locale === "es-419") return es_419_body_assessment_series_open(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_series_open(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_series_open(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_series_open(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_series_open(inputs)
	return en_us2_body_assessment_series_open(inputs)
});
export { body_assessment_series_open as "body-assessment.series_open" }